export default __webpack_public_path__ + "static/media/redelocal.fw.87010188.png";